import { SideNavLinks } from '~store/sidenav/types';

export const subscriberExplorerPageLinks: SideNavLinks[] = [
  {
    name: 'View All Subscribers',
    path: '/subscriber-explorer'
  }
];
